module.exports = __webpack_public_path__ + "img/firstNE.74164923.png";